import { environment } from './../environments/environment';
import { RedirectComponent } from './shared/components/redirect/redirect.component';
import { LoginComponent } from './login/login/login.component';
import { StagingLoginComponent } from './login/staging-login/staging-login.component';
import { LoginLazyGuard } from './shared/guards/login-lazy-guard.service';
import { DevLoginComponent } from './login/dev-login/dev-login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { ExternalLoginComponent } from './login/external-login/external-login.component';

const routes: Routes = [
  { path: '', redirectTo: 'user-redirect', pathMatch: 'full' },
  { path: 'user-redirect', component: RedirectComponent, pathMatch: 'full'},
  { path: 'login', component: LoginComponent, data: { breadcrumbTitle: 'Login' } },
  { path: 'external-login', component: ExternalLoginComponent, data: { breadcrumbTitle: 'Login' } },
  {
    path: 'wizard',
    canLoad: [LoginLazyGuard],
    data: { breadcrumbTitle: 'Invite New Partners', breadcrumbCssIcon: 'fa fa-user-plus' },
    loadChildren: () => import('./features/dealer/traxpartners-wizard/traxpartners-wizard.module').then(m => m.TraxpartnersWizardModule),
  },
  {
    path: 'partners',
    canLoad: [LoginLazyGuard],
    data: { breadcrumbTitle: 'Partners', breadcrumbCssIcon: 'fa fa-users' },
    loadChildren: () =>
      import('./features/dealer/traxpartners-partners/traxpartners-partners.module').then(m => m.TraxpartnersPartnersModule),
  },
  {
    path: 'invites',
    canLoad: [LoginLazyGuard],
    data: { breadcrumbTitle: 'Invitations', breadcrumbCssIcon: 'fa fa-envelope' },
    loadChildren: () => import('./features/dealer/traxpartners-invites/traxpartners-invites.module').then(m => m.TraxpartnersInvitesModule),
  },
  {
    path: 'discount-default',
    canLoad: [LoginLazyGuard],
    data: { breadcrumbTitle: 'Account Settings', breadcrumbCssIcon: '' },
    loadChildren: () =>
      import('./features/dealer/traxpartners-discount-default/traxpartners-discount-default.module')
        .then(m => m.TraxpartnersDiscountDefaultModule),
  },
  // Temporary route
  /*{
    path: 'partners-detail',
    component: TraxpartnersPartnersDetailComponent,
    canLoad: [LoginLazyGuard],
    data: { breadcrumbTitle: 'Partner Detail' }
  },*/
  {
    path: 'shop/find-partners',
    canLoad: [LoginLazyGuard],
    loadChildren: () => import('./features/shop/find-suppliers/find-suppliers.module').then(m => m.FindSuppliersModule),
    data: { breadcrumbTitle: 'Find Partners', breadcrumbCssIcon: 'fa fa-user-plus' }
  },
  {
    path: 'shop/partners',
    canLoad: [LoginLazyGuard],
    loadChildren: () => import('./features/shop/shop-partners/shop-partners.module').then(m => m.ShopPartnersModule),
    data: { breadcrumbTitle: 'My Partners', breadcrumbCssIcon: 'fa fa-users' }
  },
  {
    path: 'shop/invites',
    canLoad: [LoginLazyGuard],
    loadChildren: () => import('./features/shop/shop-invites/shop-invites.module').then(m => m.ShopInvitesModule),
    data: { breadcrumbTitle: 'Pending Invites', breadcrumbCssIcon: 'fa fa-envelope' }
  },
  {
    path: 'shop/integrations',
    canLoad: [LoginLazyGuard],
    loadChildren: () => import('./features/shop/integrations/integrations.module').then(m => m.IntegrationsModule),
    data: { breadcrumbTitle: 'Integrations', breadcrumbCssIcon: 'fa fa-envelope' }
  },
  {
    path: 'anonymous',
    loadChildren: () => import('./features/anonymous/anonymous.module').then(m => m.AnonymousModule),
    data: { breadcrumbTitle: 'Integrations', breadcrumbCssIcon: 'fa fa-envelope' }
  },
];
if (!environment.production) {
  routes.push({ path: 'dev-login', component: DevLoginComponent, data: { breadcrumbTitle: 'Development Login' } });
  routes.push({ path: 'staging-login', component: StagingLoginComponent, data: { breadcrumbTitle: 'Staging Login' } });
}

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor() {

  }
}
